import { i18nTranslate } from 'src/utils/i18n'
import { trackErrorInInstana } from 'src/utils'

/**
 * Looks up a customer-friendly error message in ContentStack by error code.
 * Returns the translated message when a match exists, otherwise null.
 *
 * @param {string} code - The API error code (e.g. data.code).
 * @param {string} endPointName - The API endpoint name for error tracking.
 * @returns {Promise<string|null>}
 */
async function getContentStackErrorMessage(code, endPointName) {
  try {
    if (!code) return null

    // Lazy import to avoid pulling CommonContainer → Toast → .scss into the SSR bundle
    const { contentStackContainer } = require('src/models/ContentStack/ContentStack')
    const CSErrorCodes = await contentStackContainer.getErrorCodes()

    if (!Array.isArray(CSErrorCodes) || CSErrorCodes.length === 0) return null

    const errorObj = CSErrorCodes.find(err => String(err.error_code) === String(code))

    // Success-operation codes must opt out via is_error_code: false
    if (
      errorObj?.error_code &&
      errorObj?.error_message &&
      errorObj?.is_error_code !== false
    ) {
      trackErrorInInstana({
        errorReport: 'ContentStack Error Code',
        errorData: {
          errorCode: errorObj.error_code || '',
          splunkCode: errorObj.splunk_code || '',
          errorMessage: errorObj.error_message || '',
          apiEndpoint: endPointName || '',
          originalApiCode: code,
        },
      })
      return i18nTranslate(errorObj.error_code, errorObj.error_message)
    }
    return null
  } catch (e) {
    trackErrorInInstana({
      errorReport: 'ContentStack error code lookup failed',
      errorData: e,
    })
    return null
  }
}

export { getContentStackErrorMessage }
